// Force all date/time displays across the app to Nigerian time (WAT, Africa/Lagos)
// by defaulting the timeZone on Date.prototype.toLocale* methods when the caller
// has not already specified one. Calls that explicitly pass a timeZone are untouched.
(function forceNigerianTime() {
  const TZ = 'Africa/Lagos';
  const methods = ['toLocaleString', 'toLocaleTimeString', 'toLocaleDateString'];
  methods.forEach((name) => {
    const original = Date.prototype[name];
    if (!original || original.__watPatched) return;
    const patched = function (locales, options) {
      const opts = options && options.timeZone ? options : { ...(options || {}), timeZone: TZ };
      return original.call(this, locales, opts);
    };
    patched.__watPatched = true;
    // eslint-disable-next-line no-extend-native
    Date.prototype[name] = patched;
  });
})();
